import { useEffect, useState } from "react";
import Lenis from "lenis";
import { LangContext } from "@/lang";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ChiSono from "@/components/ChiSono";
import Esperienza from "@/components/Esperienza";
import Contatti from "@/components/Contatti";
import Privacy from "@/components/Privacy";

export default function App() {
    const [lang, setLangState] = useState(
        () => localStorage.getItem("fg-lang") || "it",
    );
    const setLang = (l) => {
        setLangState(l);
        localStorage.setItem("fg-lang", l);
    };

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return undefined;
        }
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <LangContext.Provider value={{ lang, setLang }}>
            <div className="min-h-screen font-sans text-ink">
                <Nav />
                <main className="mx-auto w-full max-w-[1240px] space-y-6 px-3 pb-16 pt-20 md:space-y-10 md:px-6 md:pt-24">
                    <Hero />
                    <Marquee />
                    <ChiSono />
                    <Esperienza />
                    <Contatti />
                    <Privacy />
                </main>
            </div>
        </LangContext.Provider>
    );
}
